var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDatabaseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.9333333px",
    height: "16.6px",
    viewBox: "0 0 14.9333333 16.6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gestionnaire---Param\\xE8tres---Cat\\xE9gories",
    transform: "translate(-62.533333, -120.700000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(40.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#030303",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 10,
    cy: 5,
    rx: 6.66666667,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,5 L3.33333333,10 C3.33333333,11.3807119 6.31810167,12.5 10,12.5 C13.6818983,12.5 16.6666667,11.3807119 16.6666667,10 L16.6666667,5",
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,10 L3.33333333,15 C3.33333333,16.3807119 6.31810167,17.5 10,17.5 C13.6818983,17.5 16.6666667,16.3807119 16.6666667,15 L16.6666667,10",
    id: "Path",
    stroke: "#030303",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatabaseDark);
export default __webpack_public_path__ + "static/media/icon_database_dark.fa7257bbd85caa62b02e7bba3a3a3f16.svg";
export { ForwardRef as ReactComponent };